module.exports = __webpack_public_path__ + "img/qrcode.398afa29.jpg";